/*
    文字列入力エリアの生成用コンポーネント
    props
        placeholder:プレースホルダーに指定したい文字列
        maxlen:最大入力の文字数指定
 */

import { Validator } from "~/utils/Validator"
import React, { ChangeEvent } from "react"

interface Props {
  id?: string,
  name?: string,
  value?: string,
  placeholder?: string,
  maxLen?: number,
  required?: boolean,
  className?: string,
  readOnly?: boolean,
  onChange?: (value?: string) => void,
  regex?: string
  //onChange?: ChangeEventHandler<HTMLInputElement>
}

export function Text(props: Props) {
  const { id, name, value, placeholder, maxLen, required = false, className, readOnly, onChange, regex } = props

  return (
    <input type="text"
      id={id}
      name={name}
      className={`form-control ${className}`}
      value={value}
      placeholder={placeholder}
      maxLength={maxLen}
      required={required}
      readOnly={readOnly}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        if (maxLen) {
          Validator.maxLen(e, maxLen)
        }
        if (regex) {
          e.target.value = (String(e.target.value || "").match(new RegExp(`${regex}`, "g")) || []).join("")
        }
        onChange?.(e.target.value)
      }}
    />
  )
}